import {
  GetOrganizationGroupPath,
} from '../Util/PathHelper';

export const HandleRouteToOrganizationGroup = (props, organizationId, organizationGroupId, openInNewTab) => {
  const uri = GetOrganizationGroupPath(organizationId, organizationGroupId);
  if (openInNewTab) {
    window.open(uri, "n1_organizationGroupContent")
  } else {
    props.history.push(uri, { ...props.location.state });
  }
}
